var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDiamonds = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178.6 249.4",
    style: {
      enableBackground: "new 0 0 178.6 249.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,42.5c1.8,3.5,4.1,6.3,7.1,8.5c-2.9,2.2-5.3,5-7.1,8.5C11,56.1,8.6,53.2,5.7,51C8.6,48.8,11,46,12.8,42.5L12.8,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,189.9c1.8,3.5,4.1,6.3,7.1,8.5c-2.9,2.2-5.3,5-7.1,8.5c-1.8-3.5-4.2-6.3-7.1-8.5C161.7,196.2,164,193.4,165.8,189.9 L165.8,189.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 178.6,
    height: 249.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ace_three_five_nine"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5,105.8c4.5,8.4,10.4,15.2,17.7,20.6c-7.3,5.3-13.2,12.2-17.7,20.5c-4.5-8.4-10.4-15.2-17.7-20.5 C78.1,121,84,114.2,88.5,105.8L88.5,105.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "two_three"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3,25.5c4.5,8.7,10.4,15.8,17.7,21.3C99.7,52.3,93.8,59.4,89.3,68c-4.5-8.6-10.4-15.7-17.7-21.2 C78.9,41.3,84.8,34.2,89.3,25.5L89.3,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3,181.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C78.9,197.2,84.8,190.1,89.3,181.4L89.3,181.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "four_five_six_seven_eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1,25.5c4.5,8.7,10.4,15.8,17.7,21.3C56.4,52.3,50.6,59.4,46.1,68c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,41.3,41.6,34.2,46.1,25.5L46.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,181.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,197.2,41.6,190.1,46.1,181.4L46.1,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,25.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,41.3,128,34.2,132.5,25.5L132.5,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,181.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,197.2,128,190.1,132.5,181.4L132.5,181.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "six_seven_eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1,103.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,119.2,41.6,112.2,46.1,103.5L46.1,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,103.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,119.2,128,112.2,132.5,103.5L132.5,103.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "seven_eight_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3,66.6c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C78.9,82.4,84.8,75.3,89.3,66.6L89.3,66.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "eight_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3,140.3c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C78.9,156.1,84.8,149,89.3,140.3L89.3,140.3z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "nine_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1,25.5c4.5,8.7,10.4,15.8,17.7,21.3C56.4,52.3,50.6,59.4,46.1,68c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,41.3,41.6,34.2,46.1,25.5L46.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,77.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,93.2,41.6,86.2,46.1,77.5L46.1,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,129.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,145.2,41.6,138.1,46.1,129.4L46.1,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,181.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C35.7,197.2,41.6,190.1,46.1,181.4L46.1,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,25.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,41.3,128,34.2,132.5,25.5L132.5,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,77.5c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,93.2,128,86.2,132.5,77.5L132.5,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,129.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,145.2,128,138.1,132.5,129.4L132.5,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,181.4c4.5,8.7,10.4,15.8,17.7,21.3c-7.3,5.5-13.2,12.6-17.7,21.2c-4.5-8.6-10.4-15.7-17.7-21.2 C122.1,197.2,128,190.1,132.5,181.4L132.5,181.4z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "jack_queen_king"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.8,185.7c3.6,6.9,8.3,12.6,14.1,17c-5.9,4.4-10.6,10.1-14.1,17c-3.6-6.9-8.3-12.6-14.2-17 C123.5,198.3,128.2,192.6,131.8,185.7L131.8,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,29.8c3.6,6.9,8.3,12.6,14.2,17c-5.9,4.4-10.6,10.1-14.2,17c-3.6-6.9-8.3-12.6-14.2-17C38.5,42.4,43.2,36.7,46.8,29.8 L46.8,29.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiamonds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/diamonds.c67ef20e.svg";
export { ForwardRef as ReactComponent };